import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
} from '@angular/core';
import { RouterLink } from '@angular/router';
import { NzColDirective, NzRowDirective } from 'ng-zorro-antd/grid';
import {
  NzResultComponent,
  NzResultExtraDirective,
} from 'ng-zorro-antd/result';
import { NzButtonComponent } from 'ng-zorro-antd/button';
import { RESPONSE } from '../../../token';
import { Response } from 'express';
import { MetaService } from '../../service/meta.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-not-found-page',
  imports: [
    RouterLink,
    NzRowDirective,
    NzColDirective,
    NzResultExtraDirective,
    NzResultComponent,
    NzButtonComponent,
  ],
  templateUrl: './not-found-page.component.html',
  styleUrl: './not-found-page.component.less',
})
export class NotFoundPageComponent implements OnInit {
  private static readonly URI: '404' = '404' as const;
  private readonly metaService: MetaService = inject(MetaService);
  private readonly response: Response | null = inject<Response>(RESPONSE, {
    optional: true,
  });

  public ngOnInit(): void {
    this.metaService.setTitle(
      $localize`:@@page-not-found-title:Page not found: Ig4u`
    );
    this.metaService.setDescription(
      $localize`:@@page-not-found-description:Page not found`
    );
    this.metaService.setKeywords(
      $localize`:@@page-not-found-keywords:page not found, ig4u`
    );
    this.metaService.setCanonical(NotFoundPageComponent.URI);
    this.metaService.setAlternatives(NotFoundPageComponent.URI);
    this.metaService.disableIndexing();
    if (this.response) {
      this.response.status(404);
    }
  }
}
